// plugins/sessionStorage.js
const SessionStorage = {
    install(Vue) {
      Vue.prototype.$session = {
        set(key, value) {
          if (typeof value === 'object' && value !== null) {
            sessionStorage.setItem(key, JSON.stringify(value))
          } else {
            sessionStorage.setItem(key, value)
          }
        },
        
        get(key) {
          const value = sessionStorage.getItem(key)
          try {
            return JSON.parse(value)
          } catch (e) {
            return value
          }
        },
        
        remove(key) {
          sessionStorage.removeItem(key)
        },
        
        clear() {
          sessionStorage.clear()
        }
      }
    }
  }
  
  export default SessionStorage